import * as types from "./actionTypes";
import * as promozioniNewApi from "../../api/promozioniNewApi";

export function loadPromozioniNewSuccess(promozioni) {
  return {
    type: types.LOAD_PROMOZIONI_NEW_SUCCESS,
    promozioni,
  };
}

// promozioniNewApi.getPromozioniScuola never rejects (it resolves to null on
// any failure, including a school that does not exist in the new system), so
// there is no .catch here: the thunk always ends by dispatching a defined
// state (either the loaded config, or null).
export function loadPromozioniNew(codScuola) {
  return function (dispatch) {
    return promozioniNewApi.getPromozioniScuola(codScuola).then((promozioni) => {
      dispatch(loadPromozioniNewSuccess(promozioni));
    });
  };
}
